export default {
  BACK_TO_MY_DONORS_LABEL: 'Back to My Donors',
  DONOR_EDIT_PROFILE: 'Edit Profile',
  NEW_INTERACTION_REPORT_LABEL: 'New Interaction Report',
  DONOR_KEY_INFO: 'Key Info',
  DONOR_KEY_NOTES: '3 Key Notes',
  DONOR_ASSIGNEE_INFO_TITLE: 'Assigned',
  DONOR_ASSIGNEE_INFO_UPDATE: 'Update',
  DONOR_STAGE_INFO_TITLE: 'Donor Stage',
  DONOR_STAGE_INFO_MOVE: 'Move',
  PERSONAL_INFO_TAB: 'Personal info',
  BUSINESS_INFO_TAB: 'Business info',
  DONOR_HISTORY_TAB: 'Donor History',
  DONOR_NOTE_LABEL: 'Note',
  DONOR_NOTE_PLACEHOLDER_1: 'Goal with this donor',
  DONOR_NOTE_PLACEHOLDER_2: 'Interesting tidbit',
  DONOR_NOTE_PLACEHOLDER_3: 'Things to Avoid',
  DONOR_PERSONAL_INFORMATION: 'Personal Information',
  DONOR_WORK_INFORMATION: 'Work Information',
  DONOR_ADD_WORK_LABEL: 'Add Work Information',
  DONOR_PRIMARY_WORK_LABEL: 'Primary Work',
  DONOR_BUSINESS_INFORMATION: 'Business Information',
  DONOR_COMPANY_INFORMATION: 'Company Information',
  DONOR_HOUSEHOLD_LABEL: 'Household',
  DONOR_ADD_HOUSEHOLD_LABEL: 'Add Household Member',
  DONOR_CONTACTS_LABEL: 'Contact Information',
  DONOR_PRIMARY_CONTACT_LABEL: 'Primary Contact',
  DONOR_ADD_CONTACT_LABEL: 'Add Contact',
  DONOR_AFFILIATIONS_LABEL: 'Affiliations',
  DONOR_ADD_AFFILIATION_LABEL: 'Add Affiliation',
  DONOR_EMPLOYEES_LABEL: 'Employees',
  DONOR_ADD_EMPLOYEE_LABEL: 'Add Employee',
  DONOR_CONNECTIONS_LABEL: 'Connections',
  DONOR_ADD_CONNECTION_LABEL: 'Add Connection',
  DONOR_PRIMARY_CONTACT_INFORMATION: 'Primary Contact Information',
  DONOR_FAMILY_AND_AFFILIATIONS: 'Family and Affiliations',
  DONOR_EMPLOYEES_AND_AFFILIATIONS: 'Employees and Affiliations',
  DONOR_GIVING_SUMMARY: 'Giving Summary',
  GIVING_SUMMARY_INDIVIDUAL: 'Individual Giving Summary',
  GIVING_SUMMARY_ORGANIZATION: 'Organization Giving Summary',
  GIVING_SUMMARY_HOUSEHOLD: 'Household Giving Summary',
  GIVING_SUMMARY_EMPLOYEE: 'Employee Giving Summary',
  GIVING_PLANNED_GIVING: 'Planned Giving',
  EDIT_DONOR_PROFILE_TITLE: 'Edit Donor Profile',
  CREATE_DONOR_PROFILE_TITLE: 'Create Donor Profile',
  FIRST_NAME_LABEL: 'First Name',
  LAST_NAME_LABEL: 'Last Name',
  DISPLAY_NAME_LABEL: 'Display Name',
  EMAIL_ADDRESS_LABEL: 'Email Address',
  WORK_EMAIL_ADDRESS_LABEL: 'Work Email Address',
  PHONE_NUMBER_LABEL: 'Phone Number',
  COUNTRY_LABEL: 'Country',
  COUNTRY_ERROR_MESSAGE: 'Use two-letter country code',
  STREET_ADDRESS_LABEL: 'Street Address',
  STREET_ADDRESS_LABEL_LINE_2: 'Line 2',
  APT_LABEL: 'Apt/Suite',
  CITY_LABEL: 'City',
  STATE_LABEL: 'State',
  ZIP_LABEL: 'ZIP',
  ENTER_ADDRESS_MANUALLY: 'Enter address manually',
  SEARCH_FOR_ADDRESS: 'Search for address',
  BOARD_MEMBER_LABEL: 'Board Member',
  MAJOR_DONOR_LABEL: 'Major Donor',
  MAJOR_DONOR_THRESHOLD_LABEL: 'Major Donor Threshold',
  RECURRING_LABEL: 'Recurring',
  VOLUNTEER_LABEL: 'Volunteer',
  MEMBER_LABEL: 'Member',
  INSTAGRAM_LABEL: 'Instagram Profile',
  TWITTER_LABEL: 'Twitter Profile',
  LINKEDIN_LABEL: 'LinkedIn Profile',
  FACEBOOK_LABEL: 'Facebook Profile',
  YOUTUBE_LABEL: 'YouTube Channel',
  TIKTOK_LABEL: 'TikTok Profile',
  BIRTHDAY_LABEL: 'Birthdate',
  IS_DECEASED_LABEL: 'Is Deceased',
  DECEASED_LABEL: 'Deceased',
  BIRTHDAY_PLACEHOLDER: 'Birthdate MM/DD/YY',
  EMPLOYER_LABEL: 'Employer',
  EMPLOYEES_LABEL: 'Employees',
  TITLE_LABEL: 'Title',
  TYPE_LABEL: 'Type',
  WEBSITE_LABEL: 'Website',
  SPOUSE_LABEL: 'Spouse',
  FAMILY_MEMBER_LABEL: 'Family Member',
  CONNECTIONS_LABEL: 'Connections',
  CONNECTIONS_ANY_LABEL: 'Connections - Any',
  CONNECTIONS_EMPLOYER_LABEL: 'Connections - Employer',
  CONNECTIONS_HOUSEHOLD_LABEL: 'Connections - Household',
  COMPANY_NAME_LABEL: 'Company Name',
  COMPANY_INDUSTRY_LABEL: 'Company Industry',
  DONOR_INDUSTRY_LABEL: 'Industry',
  ADD_INDUSTRY: 'Add Industry',
  AFFILIATIONS_LABEL: 'Company Affiliations',
  COMPANY_AFFILIATION_LABEL: 'Company Affiliation',
  PRIMARY_LABEL: 'Primary',
  MOBILE_LABEL: 'Mobile',
  HOME_LABEL: 'Home',
  THREE_KEY_NOTES_LABEL: '3 Key Notes',
  DONOR_FORM_FIX_ERRORS_MESSAGE: 'Fix errors to save the donor',
  EDIT_DONOR_FORM_PERSON_LABEL: 'Person',
  EDIT_DONOR_FORM_ORG_LABEL: 'Organization',
  FRONT_DESK_LABEL: 'Front Desk',
  BILLING_LABEL: 'Billing',
  SALES_LABEL: 'Sales',
  PRIMARY_CONTACT_INFO: 'Primary Contact Information',
  SECONDARY_CONTACT_INFO: 'Secondary Contact Information',
  PRIMARY_CONTACT_NAME: 'Primary Contact Name',
  SECONDARY_CONTACT_NAME: 'Secondary Contact Name',
  ADD_SECONDARY_CONTACT: 'Add Secondary Contact',
  REMOVE_CONTACT: 'Remove Contact',
  DONOR_UPDATED_LABEL: 'Donor Updated!',
  DONOR_UPDATED_MESSAGE: 'Donor was successfully updated',
  DONOR_BOARD_ACTIONS: 'Constituent Card Actions',
  DONOR_BOARD_ACTION_INTERACTION: 'New Interaction',
  DONOR_BOARD_ACTION_DONATION: 'New Donation',
  DONOR_BOARD_ACTION_CONTRIBUTION: 'New Contribution',
  DONOR_BOARD_ACTION_MOVE_CARD: 'Move Card',
  DONOR_BOARD_ACTION_UPDATE_ASSIGNED: 'Update Assigned',
  DONOR_BOARD_ACTION_EDIT_PROFILE: 'Edit Profile',
  DONOR_BOARD_KANBAN_UPDATE_ERROR_GENERIC: 'Error updating kanban donor',
  DONOR_NAME_LABEL: 'Donor Name',
  LAST_INTERACTION_DEFAULT_LABEL: '0 days ago',
  FETCH_DONOR_INFO_ERROR_MESSAGE: 'There was a problem fetching a donor',
  CONNECTION_TYPE_LABEL: 'Connection Type',
  RELATIONSHIP_TYPE_LABEL: 'Relationship',
  DONOR_REMOVE_CONNECTION_ERROR_MESSAGE: 'There was a problem removing {name}',
  DONOR_CREATE_CONNECTION_ERROR_MESSAGE: 'There was a problem creating {name}',
  DONOR_CREATE_UPDATING_ERROR_MESSAGE: 'There was a problem updating {name}',
  CREATE_DONOR_ERROR_MESSAGE: 'There was a problem creating {name}',
  UPDATE_DONOR_ERROR_MESSAGE: 'There was a problem updating {name}',
  INVALID_EMAIL_FORMAT_MESSAGE: 'Invalid email format',
  INVALID_PHONE_FORMAT_MESSAGE: 'Invalid phone format',
  INVALID_URL_FORMAT_MESSAGE: 'Invalid URL format',
  INVALID_DATE_FORMAT_MESSAGE: 'Invalid date format',
  INVALID_DATE_MIN_MESSAGE: 'Select a date after {date}',
  INVALID_TIME_FORMAT_MESSAGE: 'Invalid time format',
  DONOR_PREFIX: 'Prefix',
  DONOR_PREFERRED_FIRST_NAME: 'Preferred Name',
  DONOR_PREFERS: 'Prefers',
  DONOR_FIRST_NAME: 'First Name',
  DONOR_LAST_NAME: 'Last Name',
  DONOR_YTD_CONTRIBUTIONS: 'YTD Contributions',
  DONOR_YTD_HOURS: 'YTD Hours',
  DONOR_YTD_IN_KIND: 'YTD In Kind',
  DONOR_CONTRIBUTIONS: 'contributions',
  DONOR_LAST_CONTRIBUTION_AMOUNT: 'Last Contribution Amount',
  DONOR_LAST_CONTRIBUTION_DATE: 'Last Contribution Date',
  DONOR_CONTRIBUTION_CY: 'Current Year Contribution Amount',
  DONOR_CONTRIBUTIONS_CY_COUNT: 'Current Year Contribution Count',
  DONOR_CONTRIBUTIONS_CY_LIST: 'List of Current Year Contributions',
  DONOR_CONTRIBUTIONS_LY: 'Last Year Contribution Amount',
  DONOR_CONTRIBUTIONS_LY_COUNT: 'Last Year Contribution Count',
  DONOR_CONTRIBUTIONS_LY_LIST: 'List of Last Year Contributions',
  DONOR_CONTRIBUTIONS_LIFETIME: 'Lifetime Contribution Amount',
  DONOR_CONTRIBUTIONS_LIFETIME_COUNT: 'Lifetime Contribution Count',
  DONOR_CONTRIBUTIONS_CY_TIME: 'Current Year Hours',
  DONOR_CONTRIBUTIONS_LY_TIME: 'Last Year Hours',
  DONOR_CONTRIBUTIONS_LIFETIME_TIME: 'Lifetime Hours',
  DONOR_CONTRIBUTIONS_LIFETIME_CONTRIBUTIONS: 'Lifetime Contributions',
  DONOR_DONATIONS_LIFETIME_INKIND: 'Lifetime In Kind',
  DONOR_ANNUAL_HOUR_SUMMARY: 'Annual Hour Summary',
  BIOGRAPHY_LABEL: 'Biography',
  PRONOUNS_LABEL: 'Pronouns',
  BIOGRAPHY_MAX_CHAR_COUNT: 'Biography must be fewer than 5,000 characters.',
  RELATION_SINGULAR_EMPLOYERS: 'Employer',
  RELATION_SINGULAR_EMPLOYEES: 'Employee',
  RELATION_SINGULAR_HOUSEHOLD: 'Household Member',
  RELATION_SINGULAR_AFFILIATIONS: 'Affiliation',
  RELATION_SINGULAR_CONNECTIONS: 'Connection',
  ADD_RELATION_DIALOG_TITLE_EMPLOYER: 'Add Employer',
  ADD_RELATION_DIALOG_TITLE_EMPLOYEE: 'Add Employee',
  ADD_RELATION_DIALOG_TITLE_HOUSEHOLD: 'Add Household Member',
  ADD_RELATION_DIALOG_TITLE_AFFILIATION: 'Add Affiliation',
  ADD_RELATION_DIALOG_TITLE_CONNECTION: 'Add Connection',
  ADD_RELATION_DIALOG_SECTION_EXISTING: 'Choose an existing constituent',
  ADD_RELATION_DIALOG_SECTION_CONJUNCTION: 'or',
  ADD_RELATION_DIALOG_SECTION_CREATE: 'Create new constituent',
  ADD_RELATION_DIALOG_SECTION_INFO: 'Relationship info',
  ADD_RELATION_DIALOG_ACTION_OPEN_PROFILE: 'Open profile in new tab',
  ADD_RELATION_DIALOG_ACTION_CLEAR_SELECTED:
    'Clear existing constituent and create new',
  ADD_RELATION_DIALOG_ACTION_SUBMIT: 'Add',
  EDIT_RELATION_DIALOG_TITLE_EMPLOYMENT:
    'Edit Employment Relationship with {displayName}',
  EDIT_RELATION_DIALOG_TITLE_HOUSEHOLD:
    'Edit Household Relationship with {displayName}',
  EDIT_RELATION_DIALOG_ACTION_SUBMIT: 'Save',
  RELATION_ACTION_REMOVE_LABEL: 'Remove {relationName}',
  RELATION_ACTION_REMOVE_CONFIRM:
    'Are you sure you want to remove this {relationName}?',
  RELATION_ACTION_EDIT_LABEL: 'Edit Relationship',
  RELATION_ACTION_MAKE_PRIMARY_CONTACT: 'Make Primary Contact',
  RELATION_ACTION_REMOVE_PRIMARY_CONTACT: 'Remove Primary Contact',
  RELATION_JOB_TITLE_INPUT_TITLE: 'Job Title',
  RELATION_LABEL_INPUT_TITLE: 'Relationship Type',
  RELATION_LABEL_PARENT: 'Parent',
  RELATION_LABEL_CHILD: 'Child',
  RELATION_LABEL_NOTES: 'Notes',
  RELATION_LABEL_PREFERRED_HOUSEHOLD_GREETING: 'Preferred Household Greeting',
  RELATION_LABEL_SPOUSE: 'Spouse/Partner',
  RELATION_LABEL_SIBLING: 'Sibling',
  RELATION_LABEL_EXTENDED_FAMILY: 'Extended Family',
  RELATION_STATUS_INPUT_TITLE: 'Relationship Status',
  RELATION_STATUS_INPUT_TITLE_EMPLOYMENT: 'Employment Status',
  RELATION_STATUS_CURRENT: 'Current',
  RELATION_STATUS_FORMER: 'Former',
  RELATION_STATUS_FORMER_LABELED: 'Former {label}',
  RELATION_STATUS_DECEASED: 'Deceased',
  RELATION_STATUS_DECEASED_LABELED: 'Deceased {label}',
  RELATION_RELATIONSHIP_START_DATE_LABEL: 'Start Date',
  RELATION_RELATIONSHIP_END_DATE_LABEL: 'End Date',
  RELATION_RELATIONSHIP_DURATION_START_ONLY: 'Since {startDate}',
  RELATION_RELATIONSHIP_DURATION_END_ONLY: 'Ends {endDate}',
  RELATION_RELATIONSHIP_DURATION: '{startDate} - {endDate}',
  RECURRING_DONATION_PLANS: 'Recurring Plans ({count})',
  RECURRING_DONATION_CADENCE: 'Cadence',
  RECURRING_DONATION_SOURCE: 'Source',
  RECURRING_DONATION_START_DATE: 'Start Date',
  ADDITIONAL_INFORMATION: 'Additional Information',
  ADDITIONAL_OPTIONS: 'Additional Options',
};
